module.exports = __webpack_public_path__ + "img/usermanage.a17524f3.svg";